import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './store/store';

import App from './components/App';
import SimpleEvents from './events/simpleEvents';

if (document.getElementById('app')) {
    ReactDOM.render(
        <Provider store={store}>
            <App />
        </Provider>,
        document.getElementById('app')
    );
}

new SimpleEvents();



// WEBPACK FOOTER //
// ./sources/js/main.js